<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Viga&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono&display=swap');
@font-face {
  font-family: 'Happy Times';
  src: url('../../../fonts/happy-times-NG_regular_master.otf');
}
@font-face {
  font-family: 'Semi Light Dots';
  src: url('../../../fonts/AC1-SemiLightDots.otf');
}
@font-face {
  font-family: 'ED Regular';
  src: url('../../../fonts/ED-Regular.otf');
}
* {
    border: 0px black solid;
    background-color: transparent;
}

.container_width {
  max-width: 100%;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 70px;
}


a:hover {
  color: hotpink;
  text-decoration: none;
}

a {
  color: gray;
}

.content {
  /*padding-right: 50px;*/
  /*padding-left: 60px;*/
  font-family: 'Happy Times';
  font-size: 18px;
  line-height: 24px;
  /*padding-bottom: 40px;*/
  color: #1B75BC;
  text-align: left;
}

.controls {
  padding-top: 12px;
  height: 120px;
  z-index: 1;
  position: relative;
  }

.title_story {
  font-size: 80px;
  font-family: 'Semi Light Dots', sans-serif;
  padding-top: 20px;
  color: #FA00FF;
  text-align: center;
}

.arrows {
  font-size: 80px;
  font-family: 'Semi Light Dots', sans-serif;
  top: 36px;
  color: #FA00FF;
  vertical-align: top;
  position: fixed;
  overflow: hidden;
}

.arrows a {
    display: block;
}

#leftarrow {
  float: left;
  color: #FA00FF;
}

#rightarrow {
  float: right;
  color: #FA00FF;
}

.image_container {
  padding-top: 5px;
}

.photo {
-webkit-filter: grayscale(100%);
        filter: grayscale(100%);
        width: auto;
  max-height: 100%;
  max-width: 100%;
  padding: 12px;
}

.img-fluid {
  filter: sepia(100%) saturate(300%) brightness(100%) hue-rotate(270deg);
}

.author {
  font-size: 20px;
  font-family: 'ED-regular', sans-serif;;
  text-align: center;
  color: #FA00FF;
}


.small_icon {
  max-width: 60%;
  padding-top: 100px;
}

.zoom {
  max-width: 100%;
}

@media (max-width: 575px){
     .small_icon {
       display: none;

     }
     .title_story {
       font-size: 48px;
     }
     .author {
       font-size: 21px;
     }

     .content {
       padding-bottom: 40px;
     }

     .photo {
       padding-bottom: 40px;
     }
   }

</style>

<template>
  <b-container fluid class="p-0">
    <MenuBar/>

    <b-row class="controls">
        <b-col md="12" class="arrows">
          <a href="/phone" id="leftarrow">←</a>
          <a href="/lychee" id="rightarrow">→</a>
        </b-col>
      </b-row>

    <b-row>
      <b-col md="4">
        <b-row>
          <b-col md="6" offset-md="3">
        <div class="zoom">

        <b-img center class="img-fluid" alt="Responsive image" src="media/magiun2/clothes.png"> </b-img>
      </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <p class="title_story">We do what we can <br> with what we have</p>
      </b-col>
    </b-row>
        <b-row>
          <b-col md="12">
            <p class="author">an essay by Raluca Chereji</p>

          </b-col>
        </b-row>
      </b-col>

  <b-col md="5">
<div class='content'>

<p>This became our house motto during quarantine. Devised at first as a way to rationalize the situation
and counter the urge to nip to the shops for that extra can of beans, or the right kind of noodles, the
saying would soon evolve into a blanket pardon for all kitchen sins. What might have been
inexcusable in normal times was now allowed, even encouraged; no transgression was off-limits.
Anything could be remedied, adjusted, forgiven.</p>
<p>
We do what we can, with what we have. Under this refrain, approximations became standard. As
long as the item substituted was vaguely in the same category as its counterpart, it was accepted. If
a recipe called for shiitake, any kind of mushroom would do. Onions and leeks became
interchangeable, herbs synonymous. Eventually, we started thinking of ingredients only in terms of
their common denominators: legumes, alliums, citrus and greens.</p>
<p>
This in turn opened the door to a kind of culinary freedom I used to scoff at. Previously a devout
follower of recipes, a measurer of quantities, I felt myself loosening up, and began to strip away
layer upon layer of prejudice. Cooking had become a game of musical chairs, and I was relearning
how to play. Sometimes the combinations worked, and sometimes they were less successful. On
occasion they were even an improvement on the original. When it came, failure was generally the
result of technique rather than taste, like the meatballs: bound with yoghurt instead of eggs, they
refused to hold their shape, and were instead fried like mince, then made into a Middle Eastern riff
on Bolognese.</p>
<p>
We do what we can, with what we have. There was always something different, a missing ingredient
replaced with something that pushed the recipe into a new territory or flavour profile.</p>
<p>
Then I wanted to have more.</p>
<p>
When lockdown started in the UK, we stopped going to the supermarket. My favourite prepandemic
routine had been to walk the length of our high street, zigzagging from shop to shop, and building
menus as I went. COVID had quickly put an end to that. Instead, I spent hours trawling the Internet
for local suppliers who accepted online orders - first for fruit and vegetables, and later bread, meat
and dairy.</p>
<p>
The online orders meant a change in habit. Not only did our meals have to be planned in advance;
ingredients also had to last, and stretched as far as possible. I turned to the freezer. Once the resting
ground for half-used bags of frozen peas and long-expired ice cream, the freezer now made all meals
possible. Breads were quartered, wrapped and frozen. Fresh herbs were bought in bulk and
suspended in time to make sure they were always on hand: dill, parsley, mint and basil, all chopped
and neatly kept in small sandwich bags. Meat was the easiest, as it often came freezer-ready from
the supplier. Egg whites, bagels, broth and chocolate cake; nothing that could be frozen wasn’t, and
every online order included something bought solely for the freezer. It became the hardestworking
appliance in the house, a treasure chest and time capsule.</p>
<p>
What we couldn’t order, we made. A casualty of the bulk-buying craze at the start of the pandemic,
pasta had become notoriously difficult to find either in-store or online. And then I remembered we
had a pasta machine. Never used and previously belonging to a relative, it had spent years in the
back of the cupboard, too heavy and complicated-looking to warrant a try. Now there was an
excuse, and it took pride of place on the kitchen counter. We didn’t experiment much with shapes,
and found it easier to cut tagliatelle with a sharp knife than the machine’s attachment. Not having a
pasta drying rack meant hanging our fresh ribbons on the clothes horse, which was both endlessly
amusing and surprisingly effective. We do what we can, with what we have.</p>
<p>
Another lesson was bread. We both hated supermarket sandwich bread, and although our local
bakery did deliver, the habit was expensive. It quickly became hard to justify spending so much on a
few loaves of sourdough, as delicious and freezer-friendly as they were. So, I started baking. After an
early and unexpected success with bagels, I moved on to bread rolls. Focaccia was next. I grew bold,
and tried my hand at burger buns and brioche. Romanian breads I loved the most, and since visiting
home was out of the question, baking them proved comforting in a spiritual sense. They were also
the most successful.</p>
<p>
What I stayed away from was sourdough. I was at once both daunted by the process, which felt
limiting and unforgiving, and repulsed by the idea of storing a living thing in the fridge. And what if
the wrong kind of bacteria developed – could I poison us?</p>
<p>
And then came the second lockdown. Indoors again, I missed sourdough, especially after a few trips
to the farmers’ market over the summer in search of loaves. So, I went for it. Building the starter
brought a new routine, a daily ritual of feeding and discarding, of watching for growth. It’s had many
names, mainly because we kept forgetting what we’d previously called it. We recently settled on
Oddish, a Pokemon reference, the idea being to avoid further evolutions. Since November it’s
yielded countless loaves, and we’ve learned to bake with it unfed to maximize tang and chew.
This past year has been a lesson in many ways. We’ve steered away from supermarkets and bought
small and local. We learned home economics. What had once been bought on a whim and left to rot
at the back of the fridge is now washed, blanched and frozen for a later day. Repertoires are
expanded and new techniques have been learned. Most importantly though, the pandemic has been
a lesson in coping, in adapting to the situation and creating new habits, meals and rituals out of what
is already there.</p>
<p> We do what we can, with what we have.</p>
</div>

      </b-col>
        </b-row>

      </b-container>
</template>

<script>
import MenuBar from '../MenuBar'
export default {
    name: 'whatwecan',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
